import { defineComponent as E, computed as r, openBlock as n, createElementBlock as c, normalizeClass as m, createElementVNode as b, unref as u, Fragment as B, renderList as D, createBlock as v, resolveDynamicComponent as F, toRaw as I, toDisplayString as g, createCommentVNode as S, withCtx as M, createTextVNode as T } from "vue";
import { sizeNameToSize as V } from "@ds/components/Icon";
import { RevLink as O } from "@ds/components/Link";
import { usePropsValidation as P } from "../../composables/usePropsValidation.js";
import H from "../../icons/generated/IconStarFilled.vue2.js";
import q from "../../icons/generated/IconStarHalf.vue2.js";
import W from "../../icons/generated/IconStarOutlined.vue2.js";
import { useLocale as X, useI18n as j } from "@ds/plugin";
import G from "../../translations/generic.translations.js";
import { tw as a } from "../../utils/tailwind.js";
import { Decimal as h, MAX_SCORE as i } from "./Rating.constant.js";
const J = ["aria-label"], K = { class: "flex" }, le = /* @__PURE__ */ E({
  name: "RevRating",
  __name: "Rating",
  props: {
    score: {},
    showScoreLabel: { type: Boolean, default: !0 },
    totalReviews: { default: void 0 },
    size: { default: "medium" },
    ratingAriaLabel: { default: void 0 },
    to: { default: void 0 }
  },
  setup(d) {
    const e = d, w = X();
    P({
      "[Rating] invalid type: score must be a number": () => typeof e.score != "number",
      "[Rating] invalid score: expected number between 0 and 5": () => e.score < 0 || e.score > i,
      "[Rating] invalid ratingAriaLabel: is required when showScoreLabel is false": () => !e.showScoreLabel && !e.ratingAriaLabel
    });
    const f = r(() => {
      const t = {
        "extra-small": a`items-center`,
        small: a`items-center`,
        medium: a``
      };
      return [a`text-action-default-hi flex items-center`, t[e.size]];
    }), x = r(() => ({
      "extra-small": a`caption-bold`,
      small: a`body-2-bold`,
      medium: a`heading-3`
    })[e.size]), R = r(() => ({
      "extra-small": a`caption-bold`,
      small: a`body-2-bold`,
      medium: a`heading-3`
    })[e.size]), p = r(() => {
      const t = Math.round(e.score * h.one) / h.one;
      return new Intl.NumberFormat(w.value).format(t);
    }), _ = r(() => `${p.value}/${i}`), y = j(), z = e.ratingAriaLabel || y(G.rating, {
      rating: p.value,
      maxRating: i
    }), L = r(
      () => e.totalReviews && e.to && e.showScoreLabel
    );
    function N(t) {
      const o = Math.floor(t), s = Number.parseFloat(t.toFixed(1)) - o;
      return s < 0.3 - Number.EPSILON ? [o, !1] : s < 0.8 - Number.EPSILON ? [o + 1, !0] : [o + 1, !1];
    }
    const A = r(() => e.score < 0 || e.score > i), C = r(() => {
      const [t, o] = N(
        e.score
      ), l = i - t, s = Array.from(Array(t)).map((Q, $) => $ + 1 === t && o ? q : H);
      if (A.value) return [];
      const k = Array.from(Array(l)).map(() => W);
      return [...s, ...k];
    });
    return (t, o) => (n(), c("span", {
      class: m(f.value)
    }, [
      b("span", {
        "aria-label": u(z),
        class: m(f.value),
        role: "img"
      }, [
        b("span", K, [
          (n(!0), c(B, null, D(C.value, (l, s) => (n(), v(F(I(l)), {
            key: s,
            "aria-hidden": "true",
            size: u(V)[d.size]
          }, null, 8, ["size"]))), 128))
        ]),
        e.showScoreLabel ? (n(), c("span", {
          key: 0,
          "aria-hidden": "true",
          class: m(["ml-4 mt-1 md:mt-2", x.value])
        }, g(_.value), 3)) : S("", !0)
      ], 10, J),
      L.value ? (n(), v(u(O), {
        key: 0,
        class: m(["text-action-default-low ml-4 mt-1 md:mt-2", R.value]),
        to: e.to
      }, {
        default: M(() => [
          T(g(`(${e.totalReviews})`), 1)
        ]),
        _: 1
      }, 8, ["class", "to"])) : S("", !0)
    ], 2));
  }
});
export {
  le as default
};
